/**
 * One pill per expected check-in: filled green once completed, red instead
 * while overdue/in danger, otherwise an empty/muted pill for one not yet
 * due. Shared by the Checker (owner) and Convoy (companion) trip cards --
 * see utilities/checker.js's checkerProgressPills for how the states
 * themselves are computed.
 *
 * @param {("done"|"attention"|"empty")[]} pills
 */
export default function CheckerProgressPills({ pills }) {
    if (!pills?.length) return null

    return (
        <div className="checker-progress-row" role="presentation">
            {pills.map((state, index) => (
                <span
                    key={index}
                    className={`checker-progress-pill checker-progress-${state}`}
                />
            ))}
        </div>
    )
}
